import * as Yup from "yup";

export const getFormSchema = (t) => {
	return Yup.object().shape({
		firstName: Yup.string().required(t("fill_required_fields")),
		lastName: Yup.string().required(t("fill_required_fields")),
		email: Yup.string()
			.required(t("fill_required_fields"))
			.email(t("invalid_format")),
		// phone: Yup.string()
		// 	.required(t("fill_required_fields"))
		// 	.test("phoneFormat", t("invalid_phone_format"), function (value) {
		// 		return matchIsValidTel(value);
		// 	}),
		// branch: Yup.string().required(t("fill_required_fields")),
		role: Yup.string().required(t("fill_required_fields")),
	});
};
